// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App__1o-Fp"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 130
// module chunks = 3